export default __webpack_public_path__ + "static/media/04_DAIF_Infra_01_02_loop.9789987a.mp4";